<template>
  <div class="BirthDateChange">
    <section-header heading="2" ja="誕生月を設定する"/>
    <div class="discription">生まれた年と月を選択してください</div>
    <p-select
      :items="birthYears"
      v-model="birthYear" />
    <p-select
      :items="birthMonths"
      v-model="birthMonth" />
    <rule v-if="birthYear === '未選択' || birthMonth === '未選択'">
      年月両方とも選択してください
    </rule>
    <normal-btn
      :disabled="!validForm"
      @click="onOK">
      誕生月を決定する
    </normal-btn>
  </div>
</template>

<script>
import PSelect from '../components/PSelect.vue'
import NormalBtn from '../components/NormalBtn.vue'
import SectionHeader from "../components/SectionHeader"
import Rule from '../components/Rule.vue'
import Protobuf from '../mixins/protobuf'
import Screen from '../mixins/screen'
import Validator from '../mixins/validator'
import { numbers } from "../assets/js/util"

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "BirthDateChange",
  components: {
    PSelect,
    NormalBtn,
    SectionHeader,
    Rule
  },
  mixins: [
    Protobuf,
    Screen,
    Validator
  ],
  data () {
    return {
      birthYear: '',
      birthYears: [],
      birthMonth: '',
      birthMonths: [],
      birthDateRules: [],
    }
  },
  computed: {
    year() {
      if (this.birthYear === '未選択') {
        return 0
      }
      const y = this.birthYear.split('年')[0]
      return parseInt(y)
    },
    month() {
      if (this.birthMonth === '未選択') {
        return 0
      }
      const m = this.birthMonth.split('月')[0]
      return parseInt(m)
    },
    birthDateRule() {
      return this.birthDateRules.length > 0 ? this.birthDateRules[0] : ''
    },
    validForm() {
      const err = this.validBirthDate(this.birthYear, this.birthMonth)
      if (err !== null) {
        return false
      }
      return true
    }
  },
  methods: {
    validateBirthDate() {
      this.birthDateRules = []
      const err = this.validBirthDate(this.birthYear, this.birthMonth)
      if (err !== null) {
        this.birthDateRules.push(err.message)
      }
    },
    onOK() {
      const err = this.validBirthDate(this.birthYear, this.birthMonth)
      if (err !== null) {
        this.birthDateRules.push(err.message)
        return
      }
      const cmdNo = pb.PlayerUpdateInfoReq.CommandNo.COMMAND_NO
      const message = pb.PlayerUpdateInfoReq.create({
        updateType: pb.PlayerUpdateInfoReq.UpdateType.BIRTH_DATE,
        birthYear: this.year,
        birthMonth: this.month,
      })
      const encorded = pb.PlayerUpdateInfoReq.encode(message).finish()
      this.post(cmdNo, encorded)
        .then(decoded => {
          if (decoded.status === pb.PlayerUpdateInfoResp.Status.SUCCESS) {
            this.$router.push({ name: 'birthDateChangeFinish', params: { month: this.birthMonth, year: this.birthYear} })
          } else {
            alert("生年月を変更できませんでした。")
          }
        })
        .catch(() => {
          this.$_error('Error', { title: '生年月変更', statusCode: 100 })
        })
    }
  },
  created() {
    const y = parseInt(this.$route.params.year)
    const m = parseInt(this.$route.params.month)
    this.birthYear = y === 0 ? '未選択' : y + '年'
    this.birthMonth = m === 0 ? '未選択' : m + '月'

    const currentYear = new Date().getFullYear()
    const ys = numbers(1900, currentYear).reverse().map(y => y + '年')
    const ms = numbers(1, 12).map(m => m + '月')
    this.birthYears = ['未選択'].concat(ys)
    this.birthMonths = ['未選択'].concat(ms)
  }
}
</script>

<style lang="scss" scoped>
.discription {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
}
</style>
